import authReducers from './auth';
import { combineReducers } from 'redux';
import projectReducers from './project';
import projectsReducers from './projects';
import statusReducers from './status';
import assessmentReducers from './assessment';

export default combineReducers({
  status: statusReducers,
  auth: authReducers,
  projects: projectsReducers,
  project: projectReducers,
  assessment: assessmentReducers
});



// WEBPACK FOOTER //
// ./src/state/index.js